import { Chat } from "@/types";

import { axios } from "../axios.instance";

export type ReadMessageRequest = {
  messageId: string;
};

export type ReadMessageResponse = Chat;

export const readMessage = async (body: ReadMessageRequest) => {
  try {
    const { data } = await axios.post(`/chats/messages/${body.messageId}/read`);

    return data as ReadMessageResponse;
  } catch (error) {}
};
